import { ArrowUp } from "lucide-react";
import React, { useState } from "react";
import { IoArrowUpSharp } from "react-icons/io5";

const UserteHeader = ({setSortBy, setOrder,sortBy,order})=>{
   
 
  function handleSortClick(field){
    if(sortBy===field){
      setOrder(order === "asc" ? "desc" : "asc")
    }else{
      setSortBy(field);
      setOrder("desc");
    }
  }
    
    
    function returnSortIcon(field){
      if(field===sortBy){
        return (
          <ArrowUp
      className={`inline ml-1 transform transition-transform duration-300 ${
       order === "desc" ? "rotate-180" : ""
      }`} 
      size={16} 
    />
        )
      }
     return <ArrowUp 
      className={`inline ml-1 transform transition-transform duration-300`} 
      size={16} 
    />
    }

  return(
  <tr className="text-white ">
    <th className="py-4 px-6 text-left cursor-pointer" onClick={()=>handleSortClick("firstName")}>
      User
       {returnSortIcon("firstName")}
    </th>
    <th className="py-4 px-6 text-left">
      Email Id
    </th>
    <th className="py-4 px-6 text-left">Speciality /Experience</th> 
    <th className="py-4 px-6 text-left">Status</th> 
  
    <th className="py-4 px-6 text-left cursor-pointer" onClick={()=>handleSortClick("createdAt")}>
        Created
       {returnSortIcon("createdAt")}
      </th>
     
      <th className="py-4 px-6 text-left cursor-pointer" onClick={()=>handleSortClick("updatedAt")}>
        Last Modified
         {returnSortIcon("updatedAt")}
      </th>
 
      <th className="py-4 px-8 text-left">Edit</th>
      <th className="py-4 px-8 text-left">Toggle</th> 
  </tr>
  )
};

export default UserteHeader;
